import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function MediaLibrary() {
  const [items, setItems] = useState([]);
  const [url, setUrl] = useState("");
  const [name, setName] = useState("");

  const load = () => api.get("/media?limit=200").then((r) => setItems(r.data.items));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!url) return;
    await api.post("/media", { url, name: name || undefined, source: url.startsWith("data:") ? "ai" : "external" });
    setUrl(""); setName(""); toast.success("Added"); load();
  };
  const del = async (id) => { await api.delete(`/media/${id}`); load(); };

  return (
    <div className="p-8 md:p-10">
      <div className="overline text-[#B4533C]">Media Library</div>
      <h1 className="font-serif text-4xl mt-1 mb-6">Images & video assets</h1>
      <form onSubmit={add} className="border border-[#D6CFC4] p-5 mb-8 flex gap-3 flex-wrap" data-testid="add-media-form">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Name (optional)" className="border border-[#D6CFC4] px-3 py-2 text-sm" />
        <input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="Image URL" className="flex-1 border border-[#D6CFC4] px-3 py-2 text-sm font-mono" data-testid="media-url-input" />
        <button className="bg-[#1B3B36] text-white px-5 py-2 text-sm" data-testid="add-media-btn">Add</button>
      </form>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.map((m) => (
          <div key={m.id} className="border border-[#D6CFC4] bg-white" data-testid={`media-${m.id}`}>
            <div className="aspect-video bg-[#EFECE5] overflow-hidden">{m.url && <img src={m.url} alt={m.name} className="w-full h-full object-cover" loading="lazy" />}</div>
            <div className="p-3">
              <div className="text-xs truncate">{m.name}</div>
              <div className="flex justify-between items-center mt-2 text-xs">
                <span className="font-mono text-[#4A4742]">{m.source}</span>
                <button onClick={() => { navigator.clipboard?.writeText(m.url); toast.success("URL copied"); }} className="text-[#1B3B36]">Copy</button>
                <button onClick={() => del(m.id)} className="text-[#B4533C]">×</button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full text-sm text-[#4A4742]">Library is empty.</div>}
      </div>
    </div>
  );
}
